import t from "./stateManager.js";
const a = new t();
export {
  a as default,
  a as representativeByIdentityManager
};
//# sourceMappingURL=representativeByIdentityManager.js.map
